export const courseSearch = (text: string, courseName: string) => {
  if (text.length)
    return courseName
      .normalize('NFD')
      .replace(
        // eslint-disable-next-line
        /([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,
        '$1'
      )
      .normalize()
      .toLowerCase()
      .includes(text.toLowerCase())
  return true
}
